/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import lightGallery from 'lightgallery'
// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

import Swiper, { Navigation, Pagination } from 'swiper'
import {
	setHrefs
} from './functions/data-hrefs'
import {
	initEqualizeContent
} from './functions/equalizer'
import {
	initTelephoneInput
} from './functions/intl-tel-input'
import {
	initDatepickerInput
} from './functions/datepicker'
import {
	enableNegativeMargins
} from './functions/negative-margins'
import {
	mapStyles
} from './functions/map-styles'
// import { enableCallrailTracking } from './functions/callrail'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/american_carports_inc_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();
	randomizeProductsOrder();

	// ADD YOUR CODE HERE
	// 
	//

	lightGallery(document.getElementById('product-page-gallery'), {
        plugins: [lgThumbnail],
        licenseKey: 'B42122F4-AE41-435C-BA3A-91BFC685EE99',
        speed: 500,
        // ... other settings
    });


	var swiper = new Swiper('#installs-swiper', {
		loop: false,
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		
		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 1,
				spaceBetween: 30,
			}
		},
	});

	jQuery('#offCanvas-product').removeClass('hide');


		var swiper = new Swiper('#categories-swiper', {
		loop: false,
		direction: 'horizontal',
		spaceBetween: 20,
		slidesPerView: 1,


		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			640: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			1024: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1200: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			1440: {
				slidesPerView: 1,
				spaceBetween: 30,
			}
		},
		
	});
	
	jQuery('.menu-item-20454').on('click', function (event) {
		if (jQuery(window).width() >= 640) {
			event.preventDefault();
		}
		jQuery('.productDropdown').slideToggle();
		jQuery(this).toggleClass('is-open');
		jQuery('#content').toggleClass('darkOverlay'); 
		jQuery('.top-bar').toggleClass('bg-primary'); 

		
	});

	jQuery(document).click(function(e){
		if((jQuery(e.target).closest(".menu-item-20454").length===0) && (jQuery(e.target).closest(".productDropdown").length===0)){
			jQuery(".productDropdown").hide('slide');
			jQuery('#content').removeClass('darkOverlay');
			jQuery('.top-bar').removeClass('bg-primary'); 
			jQuery(this).removeClass('is-open');

		};
	});

	jQuery('.tabs .tabs-title').on('click', function () {
		var childIndex = jQuery(this).index()
		var linePosition = jQuery(this).outerWidth() * childIndex;
		jQuery(this).parent().find('.tabs-underline').css('transform', 'translateX(' + linePosition + 'px)');
	});

	jQuery('#toggle-product-images').on('click', function () {
		jQuery(this).find('.fa-plus').toggleClass('hide');
		jQuery(this).find('.fa-minus').toggleClass('hide');
		jQuery('.toggle-visibility').toggleClass('hide');
	});

	jQuery('.color-box').on('click', function() {
		var bgColor = jQuery(this).data('bg-color');
		var bgName = jQuery(this).data('bg-name');

		jQuery('#popup-color-name').text(bgName);
		jQuery('#popup-color').css('background-color', bgColor);
		jQuery('#popup-color').css('display','block');
	});

	jQuery('#popup-color-close').on('click', function(e) {
			jQuery('#popup-color').css('display','none');
	});

  document.addEventListener('wpcf7mailsent', function(event) {
    window.location.href = '/thank-you/';
  }, false);


});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// PRINT CURRENT YEAR
	jQuery('.copyright-year').html(new Date().getFullYear());

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */


function randomizeProductsOrder()
{
	var $productsContainer = jQuery('.random-products-container .products'); // Adjust the selector to match your products container
	if ($productsContainer.length) {
		var $products = $productsContainer.children();
		$products.sort(function() {
			return 0.5 - Math.random();
		});
		$productsContainer.empty().append($products.slice(0,3));
	}
	jQuery('.random-products-container').removeClass('hide');
}